import { useState } from "react";
import { format } from "date-fns";

import { SafeReviews } from "@/app/types";
import { FaStar } from "react-icons/fa";

interface ReviewProps {
    review: SafeReviews;
}

const Review: React.FC<ReviewProps> = ({ review }) => {
    const { diver, rating, comment, createdAt } = review;
    const [showMore, setShowMore] = useState(false);

    const isLongComment = comment.length > 150;
    const displayedLines = showMore ? comment : comment.slice(0, 150);

    return (
        <div>
            <div>
                <span className="font-bold capitalize">{diver.user.name}</span><span className="text-sm text-neutral-600 font-light"> - {diver.loggedDives || 'No'} logged dives</span>
            </div>
            <div className="text-sm text-neutral-800 font-light mt-1">
                {diver.certifications || 'No certifications'}
            </div>
            <div className="flex items-center mt-2">
                {[...Array(5)].map((_, index) => (
                    <FaStar
                        size={12}
                        key={index}
                        className={index < rating ? 'text-yellow-500' : 'text-gray-300'}
                    />
                ))}
            </div>
            <div className="flex items-center pt-2">
                <p className="text-justify">{displayedLines}{isLongComment && (
                    <>
                        <span>... </span>
                        <button
                            className="bg-gray-300 hover:bg-gray-400 px-2 py-1 rounded-lg"
                            onClick={() => setShowMore(!showMore)}>
                            {showMore ? 'Show less' : 'Show more'}
                        </button>
                    </>
                )}</p>

            </div>
            <div className="text-sm text-neutral-800 font-light mt-1 capitalize">
                {review.reservation.listing.title}
            </div>
            <div className="text-neutral-600 font-light text-xs italic mt-2">
                {createdAt
                    ? format(new Date(createdAt), 'MMM dd, yyyy')
                    : 'Date not available'}
            </div>
        </div>
    );
};

export default Review;
